module.exports = __webpack_public_path__ + "img/9788990959669.c028c8be.jpg";